import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import Deposit from "../transactions/Deposit"
import LoginGlobal from "../data/LoginGlobal"

export default function VVIPWeeklyRewards() {
  const data = promotionsData.find(
    (promo) => promo.title === "VVIP Weekly Rewards"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isDepositOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [isDepositOpen])

  // Table Data Incase
  const tableData = [
    {
      minTurnover: "5,000,000",
      minDeposit: "₱500,000.00",
      maxBonus: "₱10,000.00",
      vipLevel: "4",
    },
    {
      minTurnover: "2,500,000",
      minDeposit: "₱250,000.00",
      maxBonus: "₱3,750.00",
      vipLevel: "3",
    },
    {
      minTurnover: "1,000,000",
      minDeposit: "₱100,000.00",
      maxBonus: "₱1,000.00",
      vipLevel: "2",
    },
    {
      minTurnover: "250,000",
      minDeposit: "₱25,000.00",
      maxBonus: "₱125.00",
      vipLevel: "1",
    },
  ]
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>VVIP Weekly Rewards</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>VVIP Weekly Rewards</h1>
                <h2>Earn Up to ₱10,000 - Exclusive for FGH High Rollers</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>Weekly Promotion</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "100px" }}
                  >
                    <thead>
                      <th>Minimum Turnover</th>
                      <th>Minimum Deposit</th>
                      <th>Maximum VVIP Bonus</th>
                      <th>VVIP Level</th>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index}>
                          <td>{row.minTurnover}</td>
                          <td>{row.minDeposit}</td>
                          <td>{row.maxBonus}</td>
                          <td>{row.vipLevel}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <strong>Qualifications: </strong>
                <ol>
                  <li>
                    <p>This promotion is open to all FGH players.</p>
                  </li>
                  <li>
                    <p>
                      Eligible players may claim a weekly VVIP bonus based on
                      their total weekly turnover and deposit - from Wednesday
                      12nn to next Wednesday 11:59am.
                    </p>
                    <span>
                      <strong className="highlight">Note: Shared Credits transactions are not counted as deposits in this promotion.</strong>
                    </span>
                  </li>
                  <li>
                    <p>
                      VVIP bonus will be credited to the qualified players'
                      account every Wednesday at 5PM.
                    </p>
                  </li>
                  <li>
                    <p>
                      All bonuses will be subjected to one-time rollover before
                      any withdrawals (all games are allowed).
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>Disclaimer:</b> FGH reserves the right to modify,
                      suspend, or terminate this promotion at any time without
                      prior notice.
                    </p>
                  </li>
                </ol>
                <div className="promotion-tnc-cta">
                  {isLoggedIn ? (
                    <button
                      type="button"
                      className="promotion-cta-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsDepositOpen(true)}
                    >
                      Play to unlock bonus
                    </button>
                  ) : (
                    <LoginGlobal
                      label="Play to unlock bonus"
                      btnClass="promotion-cta-btn"
                      onlyBtn={true}
                    />
                  )}
                </div>
                {isDepositOpen &&
                  createPortal(
                    <div className="modal-portal">
                      <Deposit
                        onClose={() => setIsDepositOpen(false)}
                        defaultBonusName="New Member Package Bonus"
                      />
                    </div>,
                    document.body
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
